/**
 * eleven Engineering — Scroll Memory (v4, 24.09.2026)
 *
 * v4: gilt jetzt für ALLE Seiten (Startseite, Landingpages, Kollektionen …).
 *     v3 hat die browsereigene Wiederherstellung global abgeschaltet, aber nur
 *     Kollektionsseiten selbst wiederhergestellt — auf der Startseite landete
 *     man nach „Zurück" deshalb immer ganz oben.
 *
 * Strategie:
 *  - Beim Verlassen einer Seite (Linkklick oder pagehide) die Scrollposition
 *    je Pfad in sessionStorage merken (30 Minuten gültig, max. 20 Seiten).
 *  - Zurück/Vor-Navigation und Neuladen: an die gemerkte Stelle springen,
 *    zwei Nachkorrekturen für Layout-Verschiebungen durch nachladende Bilder.
 *  - Kollektionen zusätzlich wie v3: nach Klick auf ein Produkt wird beim
 *    Zurückkommen die Produktkarte angesteuert (auch über den Breadcrumb).
 *  - Neuer Seitenaufruf per Link: normal oben beginnen.
 *  - BFCache-Rückkehr: Browser hat den Stand bereits, nichts tun.
 *  - Jede Nutzereingabe (wheel, touch, key, mouse) bricht die Korrektur ab.
 */
(function () {
	'use strict';

	var STORAGE_KEY   = 'eleven-scroll-mem';
	var VALID_MINUTES = 30;
	var MAX_ENTRIES   = 20;
	var REFINE_DELAYS = [150, 600];
	var SCROLL_OFFSET = 120;   // Header + Atempause (Produktkarte)

	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}

	function pageKey() { return location.pathname + location.search; }
	function isCollection() { return /\/collections\//.test(location.pathname); }

	function readAll() {
		try {
			var raw = sessionStorage.getItem(STORAGE_KEY);
			var obj = raw ? JSON.parse(raw) : {};
			return (obj && typeof obj === 'object') ? obj : {};
		} catch (_) { return {}; }
	}

	function writeAll(obj) {
		try {
			var keys = Object.keys(obj);
			if (keys.length > MAX_ENTRIES) {
				keys.sort(function (a, b) { return obj[a].t - obj[b].t; });
				keys.slice(0, keys.length - MAX_ENTRIES).forEach(function (k) { delete obj[k]; });
			}
			sessionStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
		} catch (_) {}
	}

	function save(handle) {
		var all = readAll();
		var prev = all[pageKey()] || {};
		all[pageKey()] = {
			y: Math.round(window.scrollY),
			handle: handle !== undefined ? handle : (prev.handle || ''),
			t: Date.now()
		};
		writeAll(all);
	}

	// ====================================================================
	// SAVE
	// ====================================================================
	document.addEventListener('click', function (e) {
		var link = e.target.closest && e.target.closest('a[href]');
		if (!link) return;
		var href = link.getAttribute('href') || '';
		if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
		var handle = '';
		if (isCollection()) {
			var m = href.match(/\/products\/([^/?#]+)/);
			if (m) handle = m[1];
		}
		save(handle);
	}, true);

	window.addEventListener('pagehide', function () { save(); });

	// ====================================================================
	// RESTORE
	// ====================================================================
	function navType() {
		try {
			var nav = performance.getEntriesByType('navigation')[0];
			if (nav && nav.type) return nav.type;
		} catch (_) {}
		try {
			var t = performance.navigation.type;
			return t === 2 ? 'back_forward' : (t === 1 ? 'reload' : 'navigate');
		} catch (_) {}
		return 'navigate';
	}

	function findAnchor(handle) {
		if (!handle) return null;
		var link = document.querySelector('a[href*="/products/' + handle + '"]');
		if (!link) return null;
		return link.closest('[data-product-id], .product-card, .grid__item, article, li') || link;
	}

	function targetY(data) {
		var anchor = findAnchor(data.handle);
		if (anchor) {
			return Math.max(0, anchor.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET);
		}
		return data.y;
	}

	function restore(e) {
		if (e && e.persisted) return;   // BFCache: Stand ist erhalten

		var all  = readAll();
		var data = all[pageKey()];
		if (!data) return;
		if (Date.now() - data.t > VALID_MINUTES * 60 * 1000) {
			delete all[pageKey()]; writeAll(all); return;
		}

		var type = navType();
		var historyNav = (type === 'back_forward' || type === 'reload');
		var handle = isCollection() ? (data.handle || '') : '';
		// Kollektion nach Produktklick: auch bei Rückkehr über Breadcrumb/Link
		if (!historyNav && !handle) return;
		// Produktanker nur einmal verwenden, danach zählt nur die Pixelposition
		if (handle) { data.handle = ''; all[pageKey()] = data; writeAll(all); }
		var jumpData = { y: data.y, handle: handle };

		var aborted = false;
		var events  = ['wheel', 'touchstart', 'keydown', 'mousedown'];
		function onAbort() { aborted = true; cleanup(); }
		function cleanup() {
			events.forEach(function (ev) {
				window.removeEventListener(ev, onAbort, { capture: true });
			});
		}
		events.forEach(function (ev) {
			window.addEventListener(ev, onAbort, { passive: true, capture: true, once: true });
		});

		function jump() {
			if (aborted) return;
			var y = targetY(jumpData);
			if (typeof y === 'number' && Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
		}

		jump();
		REFINE_DELAYS.forEach(function (d, i) {
			setTimeout(function () {
				jump();
				if (i === REFINE_DELAYS.length - 1) cleanup();
			}, d);
		});
	}

	window.addEventListener('pageshow', restore);
})();
